export default __webpack_public_path__ + "static/media/chevron-left.b693d802.svg";